/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Image imports
import { sBlog1, sBlog2, sBlog3 } from "../../constant/images"; // assuming these are correct

const BlogPost = () => {
  const { t } = useTranslation();
  const { id } = useParams(); // Get blog ID from URL parameters

  // Dynamic images based on blog ID
  const blogImages = {
    1: sBlog1,
    2: sBlog2,
    3: sBlog3,
  };

  // Get blog content dynamically from translation.json
  const blog = t(`blogs.blog_${id}`, { returnObjects: true });

  if (!blog || !blog.title) {
    return <div className="text-center text-2xl font-bold">Blog not found</div>;
  }

  return (
    <div className="nav-tab-wrapper tabs section-padding">
      <div className="container">
        <div className="grid grid-cols-12 gap-[30px]">
          <div className="lg:col-span-8 col-span-12">
            <div className="bg-[#F8F8F8] rounded-md">
              <img
                src={blogImages[id] || sBlog1}
                alt={`Blog ${id}`}
                className="rounded-t-md mb-10"
              />
              <div className="px-10 pb-10">
                <h3 className="text-3xl font-bold">{blog.title}</h3>
                <p className="mt-6">{blog.content.intro}</p>

                {Object.keys(blog.content)
                  .filter((key) => key !== "intro")
                  .map((sectionKey, index) => (
                    <div key={index} className="mt-10">
                      <h4 className="text-2xl font-semibold mb-4">
                        {blog.content[sectionKey].title}
                      </h4>
                      <ul className="list-disc marker:text-secondary space-y-4">
                        {blog.content[sectionKey].points.map((point, idx) => (
                          <li key={idx}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPost;
